export const LOAD_EXPENSES = 'LOAD_EXPENSES'
export const LOAD_USER_EXPENSES = 'LOAD_USER_EXPENSES'
export const SET_CURRENT_EXPENSE = 'SET_CURRENT_EXPENSE'
export const ADD_EXPENSE = 'ADD_EXPENSE'
export const LOAD_EXPENSE_STATUS = 'LOAD_EXPENSE_STATUS'
export const LOAD_EXPENSE_TYPES = 'LOAD_EXPENSE_TYPES'

